import { ListItem, ListItemText } from '@material-ui/core';
import ModeStandbyIcon from '@mui/icons-material/ModeStandby';
import { Grid } from '@mui/material';
import styles from "./ItemTraceability.module.scss";
import { capitalize } from 'helpers/utils/utils_general';
import i18n from 'i18n';

const ItemTraceability = ({ date, motive, orderNumber, responsible, node }) => {

    return (
        <ListItemText sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' }, backgroundColor: 'white' }} className={styles["item-traceability"]}>
            <Grid container sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' }}} className={styles["item-traceability-content"]} >
                <Grid xs={1} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }} />
                <Grid xs={1} className={[styles["item-icon"]].join(' ')} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' }}}>
                  <div className="table-icon">
                    <span className="circle">
                      <div></div>
                    </span>
                  </div>
                </Grid>

                <Grid xs={9} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' }, marginLeft: "10px" }}>
                    <Grid sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }} className={[styles["item-traceability-grid"]].join(' ')}>
                            <ListItemText primary={date} className={styles["item-traceability-md"]} />
                            <ListItemText className={[styles["item-traceability-orden"]].join(' ')}>{capitalize(i18n.t("order")).concat(": ")} {orderNumber}</ListItemText>
                            <ListItemText className={styles["item-traceability-sm"]}>{capitalize(i18n.t("reason")).concat(": ")} {motive}</ListItemText>
                            <ListItemText className={styles["item-traceability-sm"]}>{capitalize(i18n.t("owner")).concat(": ")} {responsible}</ListItemText>
                            <ListItemText className={styles["item-traceability-sm"]}>{capitalize(i18n.t("branch.office")).concat(": ")} {node}</ListItemText>
                    </Grid>
                </Grid>
            </Grid>
        </ListItemText>
    );
}

export default ItemTraceability;